"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BindingCount = {
    MultipleBindingsAvailable: 2,
    NoBindingsAvailable: 0,
    OnlyOneBindingAvailable: 1
};
exports.BindingCount = BindingCount;



//////////////////
// WEBPACK FOOTER
// ./node_modules/inversify/lib/bindings/binding_count.js
// module id = 133
// module chunks = 0